import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';
import { filter, switchMap, tap } from 'rxjs/operators';
import { UserService } from './utils/user.service';

/**
 * Application bootstrap component.
 */
@Component({
  selector: 'app-root',
  template: `<router-outlet />`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet]
})
export class AppComponent {
  private readonly msalService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly userService = inject(UserService);

  constructor() {
    this.msalService.handleRedirectObservable().subscribe();

    this.msalBroadcastService.msalSubject$.pipe(
      takeUntilDestroyed(),
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      tap((result: EventMessage) => {
        const account = result.payload as AccountInfo;
        this.msalService.instance.setActiveAccount(account);
      }),
      switchMap(_ => this.userService.login())
    ).subscribe();
  }
}
